<div (click)="baseService.navToHome()" [class]="classPrefix('MainPod')">
  <img  [class]="classPrefix('MainImg0')" [src]=logoImg.src [alt]="logoImg.alt | translate" />
  <h2 [class]="classPrefix('MainTitle0')">{{"NavZero.title" | translate }}</h2>
</div>
